import React, { useState, useRef } from 'react';
import { Button, ClickAwayListener } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClickableIcon, UserAvatar } from '@/components/common';
import { useAuth } from '@/hooks/useAuth';
import {
  StyledContainer,
  StyledUserButton,
  StyledUserNameText,
  StyledDropdownIcon,
  StyledPopper,
} from './AuthSection.styles';
import { UserMenu } from '../UserMenu';

const AuthSection: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, user, login, isLoading } = useAuth();

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userButtonRef = useRef<HTMLDivElement>(null);

  const handleUserMenuToggle = (): void => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const handleUserClickAway = (): void => {
    setIsUserMenuOpen(false);
  };

  const handleLogin = async (): Promise<void> => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <ClickAwayListener onClickAway={handleUserClickAway}>
          <StyledContainer>
            <ClickableIcon onClick={handleUserMenuToggle} sx={{ gap: 1 }}>
              <StyledUserButton ref={userButtonRef}>
                <StyledUserNameText variant='body2'>
                  {user?.name || t('auth.user')}
                </StyledUserNameText>
                <UserAvatar name={user?.name} />
                <StyledDropdownIcon isOpen={isUserMenuOpen} />
              </StyledUserButton>
            </ClickableIcon>

            <StyledPopper
              open={isUserMenuOpen}
              anchorEl={userButtonRef.current}
              placement='bottom-end'
            >
              <UserMenu onLogout={handleUserClickAway} />
            </StyledPopper>
          </StyledContainer>
        </ClickAwayListener>
      ) : (
        <Button variant='contained' color='primary' disabled={isLoading} onClick={handleLogin}>
          {isLoading ? t('auth.loggingIn') : t('header.login')}
        </Button>
      )}
    </>
  );
};

export default AuthSection;
